
var sprite = require("C:/git/annenberg-petspace-petbook/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 12.41 20.58\" id=\"arrow-left\" ><title>Asset 1</title><g data-name=\"Layer 2\"><path d=\"M10.91 20.58a1.5 1.5 0 0 1-1.06-.44L0 10.29 9.85.44A1.5 1.5 0 0 1 12 2.56l-7.76 7.73L12 18a1.5 1.5 0 0 1-1.06 2.56z\" data-name=\"Layer 1\"/></g></symbol>";
module.exports = sprite.add(image, "arrow-left");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-left.svg
// module id = 296
// module chunks = 1